module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Museum Abbreviations"
    }
  }, [_c('p', {
    staticClass: "fm_h",
    attrs: {
      "id": "sec3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#rsec3"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xiii",
      "title": "xiii"
    }
  }, [_vm._v("Museum Abbreviations")])])]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("BSP")])]), _vm._v(" "), _c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("Bayerische Staatssammlung für Paläontologie und Historische Geologie. Germany.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("BSPG")])]), _vm._v(" "), _c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("Bayerische Staatssammlung für Paläontologie und Geologie. Germany")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("CGM")])]), _vm._v(" "), _c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("Egyptian Geological Museum. Egypt.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("CMN")])]), _vm._v(" "), _c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("Canadian Museum of Nature. Canada.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("FSAC-KK")])]), _vm._v(" "), _c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("Faculte des Sciences Ain Chock, Universite Hassan II. Morocco.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("GZG")])]), _vm._v(" "), _c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("Geo Wissenschaftliches Zentrum der Universität Göttingen. Germany.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("JP")])]), _vm._v(" "), _c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("JuraPark. Poland.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("MDE")])]), _vm._v(" "), _c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("Le Musée des Dinosaures Espéraza-Aude. France.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("MHNM")])]), _vm._v(" "), _c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("Natural History Museum of Marrakech. Morocco.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("MN")])]), _vm._v(" "), _c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("Museu Nacional, Rio de Janeiro. Brazil.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("MNUFRJ")])]), _vm._v(" "), _c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("Museu Nacional of the Universidade Federal do Rio de Janeiro. Brazil.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("MPUR NS")])]), _vm._v(" "), _c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("Museum of Paleontology, University of Rome. Italy.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("MSNM")])]), _vm._v(" "), _c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("Museo Civico di Storia Naturale di Milano. Italy.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("OLPH")])]), _vm._v(" "), _c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("Olphin collection of the Museo Geologico e Paleontologico. Italy")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("UALVP")])]), _vm._v(" "), _c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("University of Alberta Laboratory for Vertebrate Paleontology. Canada.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("UCRC")])]), _vm._v(" "), _c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("University of California. US.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("UCPC")])]), _vm._v(" "), _c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("University of Connecticut. US.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("UMI")])]), _vm._v(" "), _c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("University Moulay Ismail. Morocco.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("USNM")])]), _vm._v(" "), _c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("National Museum of Natural History, Smithsonian Institution. US.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("ZIN")])]), _vm._v(" "), _c('td', {
    staticClass: "tdf"
  }, [_c('p', {
    staticClass: "tabf"
  }, [_vm._v("Zoological Institute, Russian Academy of Sciences. Russia."), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xiv",
      "title": "xiv"
    }
  })])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bb4f100","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Frontmatter02.vue
// module id = 84
// module chunks = 0